import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

const styles = {
  root: {
    position: "absolute",
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,.3)",
    zIndex: 9999,
    top: 0,
    left: 0
  }
}

const Overlay = ({ classes, children, bgColor = "", position}) => {
  let inlineStyle = {};
  if(bgColor)
    inlineStyle.background = bgColor;
  if(position)
    inlineStyle.position = position;

  return (
    <div style={inlineStyle} className={classes.root}>
      {children}
    </div>
  );
}

Overlay.propTypes = {
  classes: PropTypes.object.isRequired,
  bgColor: PropTypes.string,
  position: PropTypes.string
}

export default withStyles(styles)(Overlay);